
export function getConfirmationMessage(event, confirmationMessage = 'Changes you made may not be saved.') {
  if (event) {
    event.returnValue = confirmationMessage;
  }
  return confirmationMessage;
}
